<template>
  <div
    v-if="!editCard && $store.getters.myProjectListWithDetails[id]"
    class="box project-card curp df fdc"
    v-bind:class="{
      'project-card-approved': status == 'approved',
      'project-card-rejected': status == 'rejected',
      'project-inaccessible': false
    }"
  >
    <img src="/images/LockIcon.png" alt="" class="locked" />

    <div
      class="project-card-top curp"
      @click="gotoProjectPricing"
    >
      <span class="project-card-name nexa-font-bold text-nowrap inherit">{{
        newName || name
      }}</span>
      <p class="project-type gg-font">{{ newType || type }}</p>
    </div>
    <span class="project-card-bottom f1 df fdc">
      <div
        class="df fdr project-card-info f1 jcc aic curp"
        @click="gotoProjectPricing"
      >
        <p class="df fdc aic jcc">
          <span class="gg-font">Total Price</span>
          <span class="gg-font">{{ totalPrice }}</span>
        </p>
        <span class="spacer"></span>
        <p class="df fdc aic jcc">
          <span class="gg-font">Total Hours</span>
          <span class="gg-font">{{ formattedTotalHours }}hrs</span>
        </p>
      </div>
      <span class="project-card-info-2 df fdc">
        <span class="project-card-status gg-font"
          >Status: {{ status.charAt(0).toUpperCase() + status.slice(1) }}</span
        >
        <span class="project-card-created df fdr jcsb gg-font">
          <p>Created {{ formattedDate }}</p>
        </span>
        <span class="project-card-created df fdr jcsb gg-font">
          <p>Edited {{ editedDate }}</p>
          <span class="df fdr">
            <img
              v-on:click="showMenu($event)"
              class="more"
              src="/images/IconMore.svg"
              alt=""
            />
          </span>
        </span>
      </span>
      <div
        v-if="showCardMenu"
        class="box card-menu"
        v-closable="{
          handler: 'onClose'
        }"
      >
        <img
          v-on:click="onClose()"
          class="close-menu-x"
          src="/images/CloseIcon.png"
          alt=""
        />
        <span class="menu-selection" v-on:click="deleteProject()">
          <img src="/images/DeleteIcon.png" alt="" />
          <p class="gg-font">Delete Project</p>
        </span>
        <span class="menu-selection" v-on:click="duplicateProject()">
          <img src="/images/DuplicateIcon.png" alt="" />
          <p class="gg-font">Duplicate Project</p>
        </span>

      </div>
    </span>
  </div>
  <div v-else-if="editCard" class="box project-card df fdc">
    <span class="project-card-name">
      <input type="text" class="input1" v-model="projectName" />
    </span>
    <span class="df fdc project-card-info edit-card-info">
      <p>Project Type</p>
      <span class="df fdr project-types">
        <button
          v-on:click="setType('website')"
          class="button-form button-small button-smaller button-form-active"
          v-bind:class="{
            'button-deactivate': (newType || type) !== 'website'
          }"
        >
          Website
        </button>
        <button
          v-on:click="setType('web app')"
          class="button-form button-small button-smaller button-form-active"
          v-bind:class="{
            'button-deactivate': (newType || type) !== 'web app'
          }"
        >
          Web App
        </button>
      </span>
    </span>
    <span class="project-card-spacer f1"></span>
    <span v-on:click="doneEdit()" class="project-card-created df fdr jcsb">
      <p class="done-done">Done</p>
    </span>
    <div v-if="image" class="add-logo logo-exists" v-on:click="uploadLogo()">
      <img class="project-image no-move" v-bind:src="image" alt="" />
      <p class="edit-logo-text">Edit Logo</p>
    </div>
    <div v-else-if="!image" class="add-logo" v-on:click="uploadLogo()">
      <p class="edit-logo-text">Add Logo</p>
    </div>
    <input
      v-on:change="uploadLogoContinue()"
      ref="fileInput"
      id="fileUploadButton"
      style="opacity: 0; width: 0; height: 0; position: absolute;"
      type="file"
    />
  </div>
</template>

<script>
import router from "../../router";
export default {
  // import Login from '../components/Login'

  name: "ProjectCard",
  data() {
    return {
      editCard: false,
      showCardMenu: false,
      newName: null,
      newType: null,
      created: this.$store.getters.myProjectListWithDetails[this.id].created,
      edited: this.$store.getters.myProjectListWithDetails[this.id].edited,
      status: this.$store.getters.myProjectListWithDetails[this.id].status,
      type: this.$store.getters.myProjectListWithDetails[this.id].type,
      image: this.$store.getters.myProjectListWithDetails[this.id].image,
      name: this.$store.getters.myProjectListWithDetails[this.id].name
    };
  },
  props: ["id", "totalPrice", "totalHours", "cardIndex"],
  components: {},
  methods: {
    onClose() {
      console.log("onClose");
      this.showCardMenu = false;
    },
    closeMenus() {
      console.log("close menus");
    },
    uploadLogo() {
      this.$refs.fileInput.click();
    },
    uploadLogoContinue() {
      console.log("continue uploading photo");
      var inputElement = document.getElementById("fileUploadButton");
      var fileList = inputElement.files;
      if (fileList[0]) {
        var data = {
          file: fileList[0],
          projectID: this.id
        };
        console.log("file exists");
        this.$store.dispatch("saveProjectImage", data).then(() => {
          console.log("project image saved");
        });
      }
    },
    showMenu(event) {
      console.log("showMenu");
      // event ? event.stopPropagation() : null
      setTimeout(() => {
        this.showCardMenu = true;
      }, 50);
    },
    hideMenu() {
      this.showCardMenu = false;
    },
    edit() {
      this.hideMenu();
      this.editCard = true;
    },
    doneEdit() {
      this.$store
        .dispatch("saveProjectInfo", {
          id: this.id,
          name: this.newName || this.name,
          type: this.newType || this.type
        })
        .then(() => {
          console.log("after saving project details");
        });
      this.editCard = false;
    },
    setType(newProjectType) {
      this.newType = newProjectType;
      console.log("card type", this.newType);
    },
    deleteProject() {
      this.$store.dispatch("showDeleteProjectPopup", {
        projectID: this.id
      });
    },
    duplicateProject() {
      this.$store.dispatch("duplicateProject", this.id);
    },

    gotoProjectPricing() {
      router.push({
        name: 'ProjectPricingPage',
        params: { projectid: this.id, old: true },
      })
    }
  },
  events: {
    closeMenus2() {
      console.log("closeMenus2");
    }
  },
  computed: {
    formattedTotalHours() {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 1 }).format(this.totalHours)
    },
    formattedDate: function() {
      var date = new Date(this.created);
      var dateString =
        date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
      return dateString;
    },
    editedDate: function() {
      var date = new Date( this.edited || this.created);
      var dateString =
        date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
      return dateString;
    },
    projectName: {
      get: function() {
        return this.newName !== null ? this.newName : this.name;
      },
      set: function(newValue) {
        console.log("newvalue", newValue);
        this.newName = newValue;
      }
    }
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case "REMOVE_PROJECT":
          if (this.$store.getters.myProjectListWithDetails[this.id]) {
            this.image = this.$store.getters.myProjectListWithDetails[
              this.id
            ].image;
            this.status = this.$store.getters.myProjectListWithDetails[
              this.id
            ].status;
            this.type = this.$store.getters.myProjectListWithDetails[
              this.id
            ].type;
            this.name = this.$store.getters.myProjectListWithDetails[
              this.id
            ].name;
          }
          break;
        case "ADD_PROJECT":
          if (this.$store.getters.myProjectListWithDetails[this.id]) {
            this.image = this.$store.getters.myProjectListWithDetails[
              this.id
            ].image;
            this.status = this.$store.getters.myProjectListWithDetails[
              this.id
            ].status;
            this.type = this.$store.getters.myProjectListWithDetails[
              this.id
            ].type;
            this.name = this.$store.getters.myProjectListWithDetails[
              this.id
            ].name;
          }
          break;
        case "ADD_PROJECT_FULL":
          if (this.$store.getters.myProjectListWithDetails[this.id]) {
            this.image = this.$store.getters.myProjectListWithDetails[
              this.id
            ].image;
            this.status = this.$store.getters.myProjectListWithDetails[
              this.id
            ].status;
            this.type = this.$store.getters.myProjectListWithDetails[
              this.id
            ].type;
            this.name = this.$store.getters.myProjectListWithDetails[
              this.id
            ].name;
          }
          break;
      }
    });
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";

a {
  text-decoration: none !important;
}

.project-card {
  position: relative;
  height: 215px;
  min-width: 320px;
  max-width: 320px;
  border-radius: 9px;
  background-color: #ffffff;
  margin: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.31);

  & .project-card-name {
    cursor: pointer;
    z-index: 1;
  }

  & .more {
    cursor: pointer;
  }

  .project-card-top {
    padding: $projectCardPadding;
    background: $projectCardBackground;
    border-top-left-radius: $projectCardRadius;
    border-top-right-radius: $projectCardRadius;
  }
  .project-card-bottom {
    border-bottom-left-radius: $projectCardRadius;
    border-bottom-right-radius: $projectCardRadius;
    padding: $projectCardPadding;
  }
}
.project-card-approved {
  .project-card-top {
    background: $projectCardBackgroundAccepted;
  }
}
.project-card-rejected {
  .project-card-top {
    background: $projectCardBackgroundRejected;
  }
}
.done-done {
  cursor: pointer;
}
.button-form-active {
  cursor: pointer;

  * > p {
    cursor: pointer;
  }
}

.project-card-name {
  height: 23px;
  color: #ffffff;
  font-size: 18px;

  input {
    background-color: unset;
    width: 200px;
  }
}
.project-card-info {
  color: $grey2;
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 16px;
  margin-bottom: 8px;

  & > p {
    & > span:nth-child(1) {
      font-size: 12px;
      margin-bottom: 4px;
    }
    & > span:nth-child(2) {
      font-size: 18px;
      font-weight: 500;
    }
  }
  /*
  p:nth-child(2), p:nth-child(3) {
    font-weight: 600;
    margin-left: 20px;
  }*/
}
.project-card-status {
  color: $primaryColor;
  font-size: 12px;
  font-weight: 500;
  /*letter-spacing: 0.5px;*/
  line-height: 16px;
}
.project-card-rejected {
  .project-card-status {
    color: $highlightColor;
  }
}
.project-card-approved {
  .project-card-status {
    color: $highlightColor2;
  }
}
.project-card-created {
  color: $grey2;
  font-size: 12px;
  font-weight: 500;
  /*letter-spacing: 0.43px;*/
  line-height: 14px;

  & > p {
    text-transform: capitalize;
  }
}
.more {
  height: 18px;
  width: 18px;
  object-fit: contain;
  object-position: center;
}

.card-menu {
  background-color: rgba(255, 255, 255, 0.96);
  /*background-color: red;*/
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  /*transform: translateY(100%);*/
  z-index: 50;
  color: black;
  height: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;

  & > span {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    /*width: 100px;*/
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    -ms-flex-direction: row;
    -o-flex-direction: row;
    flex-direction: row;
    padding: 10px;
    padding-bottom: 0;
    cursor: pointer;

    &:last-child {
      padding-bottom: 10px;
    }

    & > p {
      margin-left: 15px;
      cursor: pointer;
    }
  }
}
.input1 {
  border: none;
  box-shadow: none;
  border-radius: 0;
  border-bottom: 1px solid #ccc;
  padding: 0;
  height: 30px;
  color: #000000;
  font-size: 24px;
  font-weight: 500;
  line-height: 43px;
}
.edit-card-info {
  margin-top: 20px;
  font-size: 12px;
}
.project-types {
  margin-top: 8px;
}
.button-form {
  margin-left: 10px;

  &:first-of-type {
    margin-left: 0;
  }
}
.project-type {
  text-transform: capitalize;
  font-size: 12px;
  color: white;
}

.add-logo {
  position: absolute;
  top: 15px;
  right: 15px;
  border-radius: 8px;
  color: #121212;
  font-size: 12px;
  background-color: #eeeeee;
  padding: 15px;
  cursor: pointer;
}

.project-image {
  height: 60px;
  width: auto;
  position: absolute;
  top: 15px;
  right: 15px;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
}

.logo-exists {
  padding: 0;
  background: none;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;

  & > p {
    margin-top: 10px;
  }
}

.no-move {
  position: relative;
  top: unset;
  right: unset;
}

.edit-logo-text {
  cursor: pointer;
}

.close-menu-x {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.project-inaccessible {
  background: $greyBoxGrey;
  .project-card-top {
    background: $grey4;
  }
  .project-card-name,
  .project-type {
    color: $grey5;
  }
  .project-card-info {
    p {
      color: $grey5;
    }
  }
  .project-card-status,
  .project-card-created {
    color: $grey5;
    p {
      color: $grey5;
    }
  }
  color: $grey5;
  pointer-events: none;
  /*opacity: 0.5;*/
}
.spacer {
  height: 14px;
  width: 1px;
  border: 1px solid $grey4;
  margin-right: 23px;
  margin-left: 23px;
}
.menu-selection {
  * {
    color: $grey2;
  }
  img {
    object-fit: contain;
  }
  p {
    font-size: 18px;
  }
}
.locked {
  display: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.project-inaccessible {
  .locked {
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
